import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], filterField: string, filterValues: any[]): any[] {
    if (!items) {
      return [];
    }
    return items.filter((val) => filterValues.includes(val[filterField]));
  }
}
